import { IUpdateManutencaoEquipObraUseCase } from "../../../presentation/useCases/update/update_manutencao_equip_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateManutencaoEquipObraUseCase
 */

export class UpdateManutencaoEquipObraUseCase implements IUpdateManutencaoEquipObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idManutencaoEquipObra: number,
    idObra?: number,
    status?: boolean,
    descricao?: string,
    dataManutencao?: Date,
    dataProxManutencao?: Date,
    dataPrevDevolucao?: Date,
    dataDevolucao?: Date,
    parteEletrica?: string,
    parteMecanica?: string,
    lubrificacao?: string,
    limpeza?: string,
    observacao?: string,
    outros1?: string,
    outros2?: string,
    descEquipamento?: string,
    idFornecedor?: number,
    descLocatario?: string,
    statusDevolucao?: boolean,
  ): Promise<void> {
    await this.repository.updateManutencaoEquipObra(
      {
        idManutencaoEquipObra,
        idObra,
        status,
        descricao,
        dataManutencao,
        dataProxManutencao,
        dataPrevDevolucao,
        dataDevolucao,
        parteEletrica,
        parteMecanica,
        lubrificacao,
        limpeza,
        observacao,
        outros1,
        outros2,
        descEquipamento,
        idFornecedor,
        descLocatario,
        statusDevolucao
      }
    );
  }
}
